(function (angular) {
    'use strict';

    angular.module('chat2')
        .factory('comapiChatService', ["$window", "$q", "$state", "$stateParams", "$rootScope", "chatClientFactory", "comapiChatStore", "jwtService", "conversationProfileService", "Html5AudioPlayer",
            function ($window, $q, $state, $stateParams, $rootScope, chatClientFactory, comapiChatStore, jwtService, conversationProfileService, Html5AudioPlayer) {

                /**
                 *  promise.$$state.status === 0 // pending
                    promise.$$state.status === 1 // resolved
                    promise.$$state.status === 2 // rejected
                 */

                var status = {
                    0: "pending",
                    1: "resolved",
                    2: "rejected"
                }

                var focussed = true;

                var win = angular.element($window)
                    .on("focus", function (event) {
                        focussed = true;
                    })
                    .on("blur", function (event) {
                        focussed = false;
                    });

                var _mutex = new COMAPI_CHAT.Mutex();
                var deferred = $q.defer();

                Html5AudioPlayer.loadSound("Pling", "/assets/audio/LipSound04.wav")
                    .catch(function (error) {
                        console.error("Failed to load 'Pling' sound", error);
                    });

                /**
                 * To play a sound, the conversation needs to be allocated to me and I must not be actively chatting in this conversation
                 * @param {*} conversation 
                 */
                function shouldPlaySound(conversation) {
                    var shouldPlay = false;

                    // is it allocated to me ?
                    if (("PLATFORMUSER\\" + jwtService.payload.sub) === conversation.allocatedTo) {

                        if (!focussed) {
                            shouldPlay = true;
                        }
                        // are we in chat in a conversation ?
                        else if ($state.current.name === "main.apiSpace.chat2.chat.conversation") {
                            // only play if we re in a different conversation
                            if ($stateParams.id !== conversation.id) {
                                shouldPlay = true;
                            }
                        } else {
                            // we are not in chat so play as it is allocated to me
                            shouldPlay = true;
                        }
                    }

                    return shouldPlay;
                }


                $rootScope.$on('MemoryConversationStore.conversationCreated', function (event, conversation) {

                    if (conversation.status !== "closed" && shouldPlaySound(conversation)) {
                        try {
                            Html5AudioPlayer.playSound("Pling");
                        } catch (e) {
                            console.error("Failed to play sound", e);
                        }
                    }
                });

                $rootScope.$on("MemoryConversationStore.statusUpdate", function (event, conversation) {

                    if (conversation.status === "new" && shouldPlaySound(conversation)) {
                        try {
                            Html5AudioPlayer.playSound("Pling");
                        } catch (e) {
                            console.error("Failed to play sound", e);
                        }
                    }
                });

                // set this to bank as we are disabling autoSynchronize ...
                var _lastQS = undefined; //"scope=profile&includeClosed=false"; // initialise to what the first request will be 

                /**
                 * Initialise chat layer
                 */
                function _initialise() {
                    return $q(function (resolve, reject) {
                        fac.chatClient.initialise(chatClientFactory.chatConfig)
                            .then(function () {
                                _lastQS = undefined;
                                resolve(true);
                            });
                    });
                }

                /**
                 * Synchronize the chat layer
                 */
                function _synchronize(qs) {
                    return _mutex.runExclusive(function () {

                        comapiChatStore.synchronising = true;
                        return fac.chatClient.messaging.synchronize(qs)
                            .then(function () {
                                comapiChatStore.synchronising = false;
                                _lastQS = qs;
                                return Promise.resolve(true);
                            })
                            .catch(function (error) {
                                comapiChatStore.synchronising = false;
                                throw error;
                            });
                    }, "_synchronize");
                }

                var fac = {
                    /**
                     * Last known presence status for logged in user
                     */
                    lastStatus: undefined,
                    /**
                     * The profileId we initialised chatClient with 
                     */
                    profileId: undefined,
                    // /**
                    //  * Cached Chat configuration
                    //  */
                    // chatConfig: {
                    //     apiSpaceId: undefined
                    // },
                    /**
                     * Chat Layer Client interface
                     */
                    chatClient: undefined,
                    /**
                     *  Method to use inside routing to ensure comapiChatService is initialised.
                     *  comapiChatService will be initialised in `main.apiSpace` route - seeing this is an async operation, 
                     *  we can wait for this to complete with this method if necessary ...
                     * 
                     *  comapiChatService.ready()
                     *      .then(function(result){
                     *          // i'm ready 🤣
                     *      });
                     */
                    ready: function () {
                        // return initialisePromise || Promise.reject({ massage: "Not initialised" });
                        return deferred.promise;
                    },
                    /** 
                     * Method to either return initialised comapiChatService or create one bootstrapping n all the overridden foundation interfaces
                     */
                    initialise: function (apiSpaceId) {

                        //initialisePromise = new Promise(function (resolve, reject) {

                        if (deferred.promise.$$state.status !== 0 /*pending*/) {
                            // the promise has already resolved / rejected - lets create a new one
                            deferred = $q.defer();
                        }

                        var currentProfileId = jwtService.payload.sub;
                        /**
                         * already initialised and apiSpaces match
                         */
                        if (fac.chatClient && chatClientFactory.chatConfig.apiSpaceId === apiSpaceId && currentProfileId === fac.profileId) {
                            deferred.resolve(true);
                        }
                        /**
                         * already initialised and apiSpaces DONT match
                         */
                        else if ((fac.chatClient && chatClientFactory.chatConfig.apiSpaceId !== apiSpaceId) || (fac.chatClient && currentProfileId !== fac.profileId)) {
                            fac.profileId = currentProfileId;
                            fac.chatClient.uninitialise()
                                .then(function () {
                                    chatClientFactory.chatConfig.apiSpaceId = apiSpaceId;
                                    comapiChatStore.setApiSpace(apiSpaceId);
                                    return _initialise();
                                })
                                .then(function () {
                                    deferred.resolve(true);
                                })
                        }
                        /**
                         * Not initialised at all
                         */
                        else {

                            fac.profileId = currentProfileId;

                            fac.chatClient = chatClientFactory.create(apiSpaceId);

                            // listen to typing events and broadcast to anyone who is interested ...
                            fac.chatClient.on("participantTyping", function (event) {
                                $rootScope.$broadcast("appMessaging.participantTyping", event);
                            });

                            fac.chatClient.on("participantTypingOff", function (event) {
                                $rootScope.$broadcast("appMessaging.participantTypingOff", event);
                            });

                            // listen to presence events for the logged in user 
                            fac.chatClient.on("webSocketEvent", function (event) {
                                switch (event.name) {
                                    case "presence.away":
                                    case "presence.offline":
                                    case "presence.available":
                                        if (event.payload.profileId.replace("PLATFORMUSER\\", "") === jwtService.payload.sub) {
                                            fac.lastStatus = event.payload.status;
                                        }
                                        break;

                                    default:
                                        // not interested ...
                                        break;
                                }
                            });

                            _initialise()
                                .then(function (result) {
                                    deferred.resolve(result);
                                });

                        }

                        return deferred.promise

                    },
                    /**
                     * 
                     */
                    addEventListener: function (type, callback) {
                        fac.chatClient.on(type, callback);
                    },
                    /**
                     * 
                     */
                    removeEventListener: function (type, callback) {
                        fac.chatClient.off(type, callback);
                    },
                    /**
                     * We only want one at a time through here
                     */
                    synchronizeConversation: function (conversationId) {

                        return _mutex.runExclusive(function () {
                            comapiChatStore.synchronising = true;
                            return fac.chatClient.messaging.synchronizeConversation(conversationId)
                                .then(function (info) {
                                    comapiChatStore.synchronising = false;
                                    return Promise.resolve(true);
                                })
                                .catch(function (error) {
                                    comapiChatStore.synchronising = false;
                                    throw (error);
                                });
                        }, "synchronizeConversation");
                    },
                    /**
                     * 
                     */
                    getConversationInfo: function (conversationId) {
                        return _mutex.runExclusive(function () {
                            comapiChatStore.synchronising = true;
                            return fac.chatClient.messaging.getConversationInfo(conversationId)
                                .then(function (conversationInfo) {
                                    comapiChatStore.synchronising = false;
                                    return conversationInfo;
                                })
                                .catch(function (error) {
                                    comapiChatStore.synchronising = false;
                                    throw (error);
                                });
                        }, "getConversationInfo");
                    },

                    /**
                     * 
                     */
                    getConversations: function (scope, filter) {

                        var includeClosed = filter === "closed";

                        var qs = "scope=" + scope + "&includeClosed=" + includeClosed;

                        return fac.synchronize(qs)
                            .then(function () {
                                return fac.chatClient.messaging.getConversations();
                            });

                    },
                    /**
                     * 
                     */
                    synchronize: function (qs) {
                        // TODO: what if APISPACE is different ?
                        if (qs === _lastQS) {
                            return Promise.resolve(true);
                        } else {
                            return _synchronize(qs);
                        }
                    },
                    /**
                     * 
                     */
                    updateConversationsFromPrimaryProfile: function (profileId, primaryProfileId) {

                        return fac.chatClient.messaging.getConversations()
                            .then(function (conversations) {
                                return conversationProfileService.applyProfileDataFromPrimary(conversations, profileId, primaryProfileId);
                            });
                    },
                    /**
                     * 
                     */
                    markAllMessagesAsRead: function (conversationId) {
                        return fac.chatClient.messaging.markAllMessagesAsRead(conversationId);
                    },
                    /**
                     * 
                     */
                    markMessageAsRead: function (message) {
                        if (!fac.chatClient.messaging.isMessageRead(message)) {
                            return fac.chatClient.messaging.markMessagesAsRead(message.conversationId, [message.id]);
                        } else {
                            return Promise.resolve(false);
                        }
                    },
                    /**
                     * 
                     */
                    getPreviousMessages: function (conversationId) {
                        return fac.chatClient.messaging.getPreviousMessages(conversationId);
                    },
                };

                return fac;
            }]);

})(window.angular);
